var _process$env$GATSBY_G;
import { createContext } from "react";
import TagManager from "react-gtm-module";
var tagManagerArgs = { gtmId: (_process$env$GATSBY_G = process.env.GATSBY_GTM_ID) !== null && _process$env$GATSBY_G !== void 0 ? _process$env$GATSBY_G : "" };
if (typeof document === "object") {
    TagManager.initialize(tagManagerArgs);
} // type GtmEvent = "trackEventNoEcommerce" | "trackVirtualPageView";
export function pushDataLayer(data) { TagManager.dataLayer({ dataLayer: data }); }
export var GtmManagerContext = /*#__PURE__*/ createContext({ push: function push() { } });
